export const urls = {
  addStorePage: "/add-store",
  historyPage: "/history",
  sendNotificationsPage: "/send-notifications",
  refreshSearchIndexPage: "/refresh-search-index",
  deadlettersPage: "/deadletters",
};
